import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VentasComponent } from './ventas/ventas.component';
import { VentasAcumuladasComponent } from './ventas-acumuladas/ventas-acumuladas.component';
import { ReciboComponent } from './recibo/recibo.component';
import { ConsultaTicketComponent } from './consulta-ticket/consulta-ticket.component';
import { SeguimientoComponent } from './seguimiento/seguimiento.component';
import { LiquidacionRegistroComponent } from './liquidacion-registro/liquidacion-registro.component';
import { AsignacionVendedorComponent } from './asignacion-vendedor/asignacion-vendedor.component';
import { CancelarVentaComponent } from './cancelar-venta/cancelar-venta.component';

const routes: Routes = [
  {
    path: '',
    children: [{ path: 'crear_venta', component: VentasComponent },
    { path: 'venta_acumulada', component: VentasAcumuladasComponent },
    { path: 'cancelar_venta', component: CancelarVentaComponent },
    { path: "recibo/:idVenta/:idComprobante", component: ReciboComponent },
    { path: "recibo/:idVenta", component: ReciboComponent },
    { path: 'consulta_ticket', component: ConsultaTicketComponent },
    { path: "seguimiento", component: SeguimientoComponent },
    { path: "seguimiento/liquidacion", component: LiquidacionRegistroComponent },
    { path: 'asignacion_vendedor', component: AsignacionVendedorComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SalesRoutingModule { }
